import {NextApi} from "../../../redux/service/Next/next";

export const GET_DEVICE_LOGS_BY_DEVICE_ID = 'GET_DEVICE_LOGS_BY_DEVICE_ID'
export const OPEN_DEVICE_LOGS_MODAL = 'OPEN_DEVICE_LOGS_MODAL'

export const getDeviceLogsByDeviceIdNext = new NextApi('device-manager/operator/logs/{deviceId}', GET_DEVICE_LOGS_BY_DEVICE_ID, {
  method: "GET", json: false,
});
